<div class="header-container" >
  <div class="logo-container">
    <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><img id="companylogo" alt="My image name" [src]="companylogo"></a>
  </div>

</div>

<div class="header-container" [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Cerrando sesión...">
<button  *ngIf="newActionsMenu.length > 0"  [nbContextMenu]="newActionsMenu" nbContextMenuTag="newactions-context-menu" nbButton status="primary"><nb-icon icon="plus-circle-outline"></nb-icon>Nuevo</button>

  <nb-actions size="small">
    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name +' ' +user?.surname"
               [title]="user?.acl_roles"
               >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<ng-template #companyaction let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Seleccionar compañía</nb-card-header>
    <nb-card-body>Selecciona la compañía para poder crear un nuevo {{data.target}}
<!--
            <nb-select placeholder="compañía" fullWidth name="role" [(ngModel)]="selectedCompany">
              <nb-option [value]="item.id" *ngFor="let item of companies">{{item.name}}</nb-option>
            </nb-select>
-->            
            <angular2-multiselect [data]="companies" 
            [(ngModel)]="selectedCompany" 
            [settings]="settings">
          </angular2-multiselect>
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="success" (click)="ejecutarNewAction(data.destino);ref.close()">Nuevo {{data.target}}</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
